import { RewardProvider } from "../enums";
import { AccountConfigurationContentProviderDto } from "./content-providers";

export interface AccountUrlsConfigurationTagDto {
  title?: string;
  urls?: string;
  useIn?: string;
}

export interface UrlsConfigurationDto {
  secretGestureDestinationUrl?: string;
  tags?: AccountUrlsConfigurationTagDto;
}

export interface ActivationTransactions {
  reportName: string;
  isReportEnabled: boolean;
}

export interface AccountConfigurationReport {
  activationTransactions?: ActivationTransactions;
}
export interface AccountConfigurationSecurity {
  isPinCodeEnabled: boolean;
}

export interface AccountConfigurationDigitalScreensDto {
  isEnabled: boolean;
}

export interface AccountConfigurationSmsApiDto {
  isEnabled: boolean;
}

export interface AccountConfigurationLoyaltyDto {
  ambassadorFeatureAvailable: boolean;
  ambassadorEnabled: boolean;
}

export interface AccountConfigurationIntegrationDto {
  name?: string;
  subSystem?: string;
}

export interface AccountConfigurationDto {
  templatesConfiguration: AccountTemplateConfiguration;
  urlsConfiguration: UrlsConfigurationDto;
  reporting?: AccountConfigurationReport;
  security: AccountConfigurationSecurity;
  digitalScreens?: AccountConfigurationDigitalScreensDto;
  externalConnection: AccountConfigurationExternalConnectionDto;
  smsApi?: AccountConfigurationSmsApiDto;
  loyalty: AccountConfigurationLoyaltyDto;
  integration?: AccountConfigurationIntegrationDto;
  rewardProviders: RewardProvider[];
}

export interface AccountTemplateConfiguration {
  isReadOnly: boolean;
  isAllEditableTemplatesAllowed: boolean;
  allowedEditableTemplates: number[];
}

export interface AccountConfigurationExternalConnectionDto {
  contentProviders?: AccountConfigurationContentProviderDto[];
}
